<template>
  <div id="chooseGoodsPurchasePrice">
    <div class="invoicingHead" style="height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a
            @click="jumpTT('/invoicingFather/addGoodsPurchaseReturn')"
            href="javascript:;"
            >选择进货单</a
          >
        </el-breadcrumb-item>
        <el-breadcrumb-item>进货单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="searchGroup">
      <div>
        <el-input
          size="small"
          placeholder="输入单号"
          v-model="orderCode"
          style="width: 200px;"
        ></el-input>
        <el-button size="small" @click="search" type="primary">搜索</el-button>
      </div>
      <div>
        <el-select size="small" v-model="synthesisOrderType" placeholder="排序">
          <el-option
            v-for="item in synthesisOrderTypeList"
            :key="item.value"
            :label="item.value"
            :value="item.name"
          ></el-option>
        </el-select>
        <el-date-picker
          v-model="dataTime"
          :clearable="false"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dataTimeChoose"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-select size="small" v-model="repository" shopStore="入库仓库">
          <el-option
            v-for="item in repositoryList"
            :key="item.repositoryId"
            :label="item.repositoryName"
            :value="item.repositoryId"
          ></el-option>
        </el-select>
        <el-select size="small" v-model="shopWorkerUserId" placeholder="经手人">
          <el-option
            v-for="item in handlerList"
            :key="item.shopWorkerUserId"
            :label="item.fullName"
            :value="item.shopWorkerUserId"
          ></el-option>
        </el-select>
        <el-button
          size="small"
          style="margin-left:10px"
          @click="deleteSearch"
          type="primary"
          >清除</el-button
        >
        <el-button size="small" @click="search" type="primary">完成</el-button>
      </div>
      <!-- <div style="padding-right: 20px">
            <el-input size="small" placeholder="输入单号" v-model="orderCode" style="width: 200px;"></el-input>
            <el-button size="small" @click="search" type="primary">搜索</el-button>
        </div> -->
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          align="center"
          prop="goodsName"
          label="进货商品"
          width="180"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="repositoryName"
          label="入库仓库"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="supplierName"
          label="供应商"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="orderCode"
          label="单号"
        ></el-table-column>
        <el-table-column align="center" prop="accountPayable" label="金额">
          <template slot-scope="scope">
            ￥{{ scope.row.accountPayable }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="业务日期"
        ></el-table-column>
        <el-table-column align="center" prop="inStorageStatus" label="状态">
          <template slot-scope="scope">
            <div
              v-if="scope.row.inStorageStatus == 0"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #AFAFAF;margin:auto;color:#AFAFAF;font-size:10px;"
            >
              未入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 1"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #FDB99E;margin:auto;color:#FDB99E;font-size:10px;"
            >
              入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 2"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #6ABCF8;margin:auto;color:#6ABCF8;font-size:10px;"
            >
              部分入库
            </div>
            <div
              v-if="scope.row.inStorageStatus == 3"
              style="width:60px;height:30px;line-height:30px;border-radius:10px;border: 1px solid #ccc;margin:auto;color:#ccc;font-size:10px;"
            >
              作废
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button class="button5" @click="refundGoods(scope.row)"
              >退货</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div v-if="tableData.length > 0" style="float:right;margin-top:10px;">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="queryInfo.pageNum"
          :page-size="queryInfo.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  repositoryList,
  Shop_handlerList,
  goodsPurchaseList,
  goodsPurchaseListTotalNum
} from "../api";
export default {
  data() {
    return {
      userList: {},
      synthesisOrderType: "",
      synthesisOrderTypeList: [
        { name: "", value: "全部排序" },
        { name: 0, value: "业务日期" },
        { name: 1, value: "单号" },
        { name: 2, value: "供应商名称" },
        { name: 3, value: "金额" }
      ],
      dataTime: "",
      startDate: "",
      endDate: "",
      repository: "",
      repositoryList: [],
      shopWorkerUserId: "",
      handlerList: [],
      orderCode: "",
      tableData: [],
      queryInfo: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      str: "",
      status: ""
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    this.userList = userList;
    this.getRepositoryList();
    this.goodsPurchaseList();
  },
  methods: {
    //跳转
    jumpTT(adress, message) {
      this.$router.push({ path: adress, query: { docId: message } });
    },
    // 清空搜索内容
    deleteSearch() {
      this.dataTime = "";
      this.repository = "";
      this.shopWorkerUserId = "";
      this.synthesisOrderType = "";
      this.orderCode = "";
      this.startDate = "";
      this.endDate = "";
      this.goodsPurchaseList();
    },
    // 搜索
    search() {
      this.status = 1;
      this.queryInfo.pageNum = 1;
      this.goodsPurchaseList(
        this.synthesisOrderType,
        this.startDate,
        this.endDate,
        this.repository,
        this.shopWorkerUserId,
        this.orderCode
      );
    },
    // 仓库
    getRepositoryList() {
      repositoryList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        isNeedAll: 1,
        pageNo: 1,
        row: 9999,
        shopStoreId: this.shopStoreId
      }).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.repositoryList = res.data;
          this.repositoryList.unshift({
            repositoryName: "全部仓库",
            repositoryId: ""
          });
          this.Shop_handlerList();
        }
      });
    },
    // 经手人列表
    Shop_handlerList() {
      Shop_handlerList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: 1,
        row: 99999
      }).then(res => {
        if (res.code == 1) {
          this.handlerList = res.data[0].workers;
          this.handlerList.unshift({
            fullName: "全部经手人",
            shopWorkerUserId: ""
          });
        }
      });
    },
    // 选择业务时期
    dataTimeChoose() {
      this.startDate = this.dataTime[0];
      this.endDate = this.dataTime[1];
    },
    // 获取进货列表
    goodsPurchaseList(
      synthesisOrderType,
      startDate,
      endDate,
      repository,
      handlerId,
      orderCode
    ) {
      goodsPurchaseList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        isManager: 1,
        pageNo: this.queryInfo.pageNum,
        row: this.queryInfo.pageSize,
        synthesisOrderType: synthesisOrderType,
        startDate: startDate,
        endDate: endDate,
        repositoryId: repository,
        handlerId: handlerId,
        orderCode: orderCode
      }).then(res => {
        if (res.code == 1) {
          this.tableData = res.data;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].productJson.length > 1) {
              this.str = this.tableData[i].productJson
                .map(item => item.goodsName)
                .join(",");
              this.tableData[i].goodsName = this.str;
            } else {
              this.tableData[i].goodsName = this.tableData[
                i
              ].productJson[0].goodsName;
            }
            if (this.tableData[i].isDestroy == 1) {
              this.tableData[i].inStorageStatus = 3;
            }
          }
          goodsPurchaseListTotalNum({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            isManager: 1,
            pageNo: this.queryInfo.pageNum,
            row: this.queryInfo.pageSize,
            synthesisOrderType: synthesisOrderType,
            startDate: startDate,
            endDate: endDate,
            repositoryId: repository,
            handlerId: handlerId,
            orderCode: orderCode
          }).then(res => {
            if (res.code == 1) {
              this.total = res.data.totalNum;
            }
          });
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(newVal) {
      this.queryInfo.pageNum = newVal;
      if (this.status == 1) {
        this.goodsPurchaseList(
          this.synthesisOrderType,
          this.startDate,
          this.endDate,
          this.repository,
          this.shopWorkerUserId,
          this.orderCode
        );
      } else {
        this.goodsPurchaseList();
      }
    },
    handleSizeChange(newVal) {
      this.queryInfo.pageSize = newVal;
      this.goodsPurchaseList();
    },
    // 退货
    refundGoods(row) {
      console.log(row, "退货");
      if (row.inStorageStatus == 0) {
        this.$message.error("该订单商品全部未入库，无可操作商品");
        return;
      } else if (row.inStorageStatus == 3) {
        this.$message.error("已作废的订单不能关联");
        return;
      }
      this.$router.push("/invoicingFather/choosePurcharseGoods");
      localStorage.setItem("orderCode", row.orderCode);
      localStorage.setItem("orderId", row.orderId);
    }
  }
};
</script>

<style scoped>
.searchGroup {
  position: absolute;
  top: 120px;
  padding-left: 20px;
  width: calc(100vw - 270px);
  height: 100px;
  background-color: #f8f8f8;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.content {
  position: absolute;
  top: 250px;
  width: calc(100vw - 230px);
  padding: 20px;
  box-sizing: border-box;
}
::v-deep .el-range-editor.el-input__inner {
  position: relative;
  top: 5px;
}
::v-deep .el-table th {
  background-color: #f8f8f8;
}
</style>
<style>
/* .el-table th {
    background-color: #F8F8F8;
} */
/* .el-date-editor .el-range__icon {
    padding-left: 6px;
    box-sizing: border-box;
}
.el-date-editor .el-range__icon {
    padding: 0;

} */
/* .el-range-editor.el-input__inner {
    position: relative;
    top: 5px;
    height: 32px;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/chooseGoodsPurchasePrice.vue